/** Formats an ISO-8601 string into 
 *  “Month DaySuffix, Year HH:MM AM/PM” */
 export function formatDate(isoString) {
    if (!isoString) return '—';
    const [datePart, timePart] = isoString.split('T');
    const [year, month, day] = datePart.split('-');
    const [hourRaw, minuteRaw] = timePart.split(':');
    const h = parseInt(hourRaw, 10), m = minuteRaw;
    const hour12 = h % 12 || 12;
    const ampm = h >= 12 ? 'PM' : 'AM';
    const suffix =
      ['11','12','13'].includes(day) ? 'th'
      : day.endsWith('1')               ? 'st'
      : day.endsWith('2')               ? 'nd'
      : day.endsWith('3')               ? 'rd'
      : 'th';
    const names = [
      'January','February','March','April','May','June',
      'July','August','September','October','November','December'
    ];
    return `${names[parseInt(month,10) - 1]} ${parseInt(day,10)}${suffix}, ${year} ` +
           `${hour12}:${m} ${ampm}`;
  }
  